// components/DateRangeSelect.jsx
import React, { useMemo} from "react";
import Select from "react-select";
import { FILTROS_BACKEND } from "../../../constants/FiltrosFechas";

function DateRangeSelect({ distribucionData, value, onChange }) {
    const mesesConDatos = distribucionData;

    const options = useMemo(() => {
        const opcionesRapidas = FILTROS_BACKEND.filter(
            (f) => typeof f.label === "string"
        ).map((filtro) => ({
            value: filtro.id,
            label: filtro.label,
        }));

        const opcionesMeses = FILTROS_BACKEND.filter(
            (f) => typeof f.label === "number"
        ).map((filtro) => ({
            value: filtro.id,
            label: filtro.label,
            isDisabled: false,
        }));

        return [
            { label: "Rangos rápidos", options: opcionesRapidas },
            { label: "Por mes", options: opcionesMeses },
        ];
    }, [mesesConDatos]);

    const selectedOption = useMemo(() => {
        if (!value) return null;

        const todasLasOpciones = [
            ...options[0]?.options || [],
            ...options[1]?.options || [],
        ];

        return todasLasOpciones.find((opt) => opt.value === value) || null;
    }, [value, options]);

    return (
        <Select
            options={options}
            value={selectedOption}
            onChange={(selected) => onChange(selected ? selected.value : null)}
            placeholder="Seleccionar periodo..."
            isSearchable
            noOptionsMessage={() => "No hay opciones disponibles"}
            styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#B04708" : "#ced4da",
                    boxShadow: state.isFocused
                        ? "0 0 0 1px #B04708"  
                        : base.boxShadow,
                    outline: "none",
                    "&:hover": {
                        borderColor: state.isFocused ? "#B04708" : "#adadad",
                    },
                }),

                groupHeading: (base) => ({
                    ...base,
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#B04708",
                    backgroundColor: "#ffeadeff",
                    padding: "8px 12px",
                }),

                option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                        ? "#B04708"
                        : state.isFocused && !state.isDisabled
                            ? "#fff2f0ff"
                            : "white",
                    color: state.isDisabled
                        ? "#aaa"
                        : state.isSelected
                            ? "white"
                            : "#333",
                    opacity: state.isDisabled ? 0.6 : 1,
                    cursor: state.isDisabled ? "not-allowed" : "default",
                }),
            }}
        />
    );
}

export default DateRangeSelect;